var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33325C11.682 1.33325 14.6667 4.31859 14.6667 7.99992C14.6667 11.6813 11.682 14.6666 8.00004 14.6666C4.31804 14.6666 1.33337 11.6813 1.33337 7.99992C1.33337 4.31859 4.31804 1.33325 8.00004 1.33325ZM8.00004 2.44459C4.93671 2.44459 2.44471 4.93659 2.44471 7.99992C2.44471 11.0633 4.93671 13.5553 8.00004 13.5553C11.0634 13.5553 13.5554 11.0633 13.5554 7.99992C13.5554 4.93659 11.0634 2.44459 8.00004 2.44459ZM7.50004 3.99992C7.75304 3.99992 7.96237 4.18814 7.99544 4.4321L8.00004 4.49992V7.99992H10.1667C10.4427 7.99992 10.6667 8.22392 10.6667 8.49992C10.6667 8.75292 10.4785 8.96225 10.2345 8.99532L10.1667 8.99992H7.50004C7.24704 8.99992 7.03771 8.81172 7.00464 8.56772L7.00004 8.49992V4.49992C7.00004 4.22392 7.22404 3.99992 7.50004 3.99992Z",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3e40f4c0d397f76a19962172bb73eb98.svg";
export { ForwardRef as ReactComponent };